import React, { FC } from 'react';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { CoreUtils } from '@nhl/nhl-breakaway-ui';

import { StateType } from '~/redux/types';

import RecapVideos from '../../components/recapVideos/RecapVideos';
import { GameCenterViewType } from '../../enums';
import { SectionContainer, StyledTabBar } from '../../styles';
import { CommonGCGame, GameCenterTab } from '../../types';

type Props = {
    game: CommonGCGame;
};

const TabBar: FC<Props> = ({ game }) => {
    const navigate = useNavigate();
    const intl = useIntl();
    const { date, gameId, matchup, month, view, year } = useParams();
    const rightRail = useSelector((state: StateType) => state.rightRail);

    const limitedScoringTabs: Array<GameCenterTab> = [
        CoreUtils.isGameLive(game.gameState)
            ? {
                  key: GameCenterViewType.SUMMARY,
                  label: intl.formatMessage({
                      description: 'Label which indicates that when a user clicks it they will see a summary view.',
                      defaultMessage: 'Summary',
                  }),
                  link: `/gamecenter/${matchup}/${year}/${month}/${date}/${gameId}/${GameCenterViewType.SUMMARY}`,
                  ariaControlId: `${GameCenterViewType.SUMMARY}-tabpanel`,
              }
            : {
                  key: GameCenterViewType.SUMMARY,
                  label: intl.formatMessage({
                      description:
                          'A section label which indicates that when a user clicks it they will see a summary view. (In English we use "summary" but in other locales we use the translation of "recap")',
                      defaultMessage: 'Summary',
                  }),
                  link: `/gamecenter/${matchup}/${year}/${month}/${date}/${gameId}/${GameCenterViewType.SUMMARY}`,
                  ariaControlId: `${GameCenterViewType.SUMMARY}-tabpanel`,
              },
        {
            key: GameCenterViewType.BOXSCORE,
            label: intl.formatMessage({
                description: 'Label which indicates that when a user clicks it they will see a box score.',
                defaultMessage: 'Box Score',
            }),
            link: `/gamecenter/${matchup}/${year}/${month}/${date}/${gameId}/${GameCenterViewType.BOXSCORE}`,
            ariaControlId: `${GameCenterViewType.BOXSCORE}-tabpanel`,
        },
    ];

    const tabs: Array<GameCenterTab> = game.limitedScoring
        ? limitedScoringTabs
        : [
              ...limitedScoringTabs,
              {
                  key: GameCenterViewType.PLAYBYPLAY,
                  label: intl.formatMessage({
                      description: 'Label which indicates that when a user clicks it they will see the play by play.',
                      defaultMessage: 'Play-By-Play',
                  }),
                  link: `/gamecenter/${matchup}/${year}/${month}/${date}/${gameId}/${GameCenterViewType.PLAYBYPLAY}`,
                  ariaControlId: `${GameCenterViewType.PLAYBYPLAY}-tabpanel`,
              },
          ];

    const onSelectedTab = (tab: GameCenterTab) => {
        navigate(tab.link);
    };

    return (
        <SectionContainer>
            <StyledTabBar
                tabs={tabs}
                selectedTab={tabs.find((tab) => tab.key === view) || tabs[0]}
                onChangeSelectedTab={onSelectedTab}
            />
            <RecapVideos gameVideo={rightRail.gameVideo} />
        </SectionContainer>
    );
};

export default TabBar;
